import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

const ResponseFeedbackModal = ({closeResponseFeedbackModal, responseFeedback}) => {

    const DEFAULT_STATUS = 401

    const MAP_RESPONSE_STATUS = {
        100: 'All information regarding this customer has been deleted.',
        101: 'The request is being processed and the corresponding data will be sent to our legal team for review',
        200: 'Our system already contains medical data on this patient. Only non-medical relevant information has been deleted.',
        201: 'Our system already contains medical or business related data on this patient. Only non relevant information has been deleted.',
        300: 'Patient was already deleted.',
        301: 'No information about this patient could be deleted as it is either of a transactional or medical nature which we are required to keep by law.',
        400: 'Patient could not be deleted. Please contact the engineering team.',
        401: 'Something went wrong. Please contact the Engineering team.',
        600: 'An error has occurred. Change could not be saved. Please try again later or contact the engineering team',
        601: 'The Change has been successfully made',
        602: 'The value -empty- is not allowed, please select true or false'
    }

    let resValue = 'response-modal-fail-mode'
    let iconClass = 'fa-times-circle'
    let text = MAP_RESPONSE_STATUS[(responseFeedback.status !== null) ? responseFeedback.status : DEFAULT_STATUS]

    if (responseFeedback.responseValue === true) {
        resValue = 'response-modal-success-mode'
        iconClass = 'fa-check-circle'

    }
    if (responseFeedback.status === 301) {
        resValue = 'response-modal-info-mode'
        iconClass = 'fa-exclamation-circle'
    }

    return (
        <ReactModal
            isOpen={responseFeedback.responseFeedbackModalOpen}
            className="response-modal"
            overlayClassName="confirmation-modal-overlay"
            onRequestClose={closeResponseFeedbackModal}
            contentLabel='Response Feedback'>

            <div className="response-modal-content">
                <div className={`response-modal-header ${resValue}`}>
                    <button type="button" className="close response-modal-button"
                            onClick={closeResponseFeedbackModal}>&times;</button>
                    <div className="modal-title text-center">
                        <i className={`fa response-modal-icon fa-inverse ${iconClass}`}/>
                    </div>
                </div>

                <div className="response-modal-body">
                    <div className='response-modal-text'>
                        {text}
                    </div>
                </div>
                <div className="response-modal-footer">
                    <button type="button" className="btn btn-default" onClick={closeResponseFeedbackModal}>Close
                    </button>
                </div>
            </div>

        </ReactModal>
    )
}

ResponseFeedbackModal.propTypes = {
    responseFeedback: PropTypes.object.isRequired,
    closeResponseFeedbackModal: PropTypes.func.isRequired,
}

export default ResponseFeedbackModal



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/ResponseFeedbackModal.js